"use client"

interface TextHTMLProps {
  text: string
  showHtml?: boolean
  maxLength?: number
}

/**
 * Text HTML component.
 * @param text - The text to display.
 * @param showHtml - To display the text with HTML tags.
 * @param maxLength - The maximum length of the text to display.
 * @returns The Text HTML component.
 */
export function TextHTML({ text, showHtml = true, maxLength }: TextHTMLProps) {
  if (!text) return null
  if (showHtml) {
    if (maxLength) {
      return (
        <div
          className="prose prose-sm text-md text-tertiary [&_a]:text-primary [&_blockquote]:border-secondary max-w-none [&_a]:underline [&_b]:font-semibold [&_b]:text-inherit [&_blockquote]:my-3.5 [&_blockquote]:border-l-4 [&_blockquote]:pl-4 [&_em]:text-inherit [&_em]:italic [&_i]:text-inherit [&_i]:italic [&_ol]:ml-7 [&_ol]:list-decimal [&_strong]:font-semibold [&_strong]:text-inherit [&_u]:text-inherit [&_u]:underline [&_ul]:ml-7 [&_ul]:list-disc"
          dangerouslySetInnerHTML={{ __html: truncateText(text, maxLength) }}
        />
      )
    }
    return (
      <div
        className="prose prose-sm text-md text-tertiary [&_a]:text-primary [&_blockquote]:border-secondary max-w-none [&_a]:underline [&_b]:font-semibold [&_b]:text-inherit [&_blockquote]:my-3.5 [&_blockquote]:border-l-4 [&_blockquote]:pl-4 [&_em]:text-inherit [&_em]:italic [&_i]:text-inherit [&_i]:italic [&_ol]:ml-7 [&_ol]:list-decimal [&_strong]:font-semibold [&_strong]:text-inherit [&_u]:text-inherit [&_u]:underline [&_ul]:ml-7 [&_ul]:list-disc"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    )
  } else {
    const textWithoutHtml = text.replace(/<[^>]*>/g, "")
    if (maxLength) {
      return (
        <p className="text-md text-tertiary">
          {truncateText(textWithoutHtml, maxLength)}
        </p>
      )
    }
    return <p className="text-md text-tertiary">{textWithoutHtml}</p>
  }
}

export function truncateText(text: string, limit: number): string {
  return text.length > limit ? `${text.slice(0, limit)}...` : text
}
